import { appendItem } from '@/utils/localStorageHelper';
import { putData } from '@/utils/apiHelper.js';

const minutes = 1;

function changeMinutesToMiliSeconds(minutes) {
  return minutes * 60 * 1000;
}

export function addSpinningClass(id) {
  let refreshIcon = document.getElementById(`refreshIcon-${id}`);
  refreshIcon.classList.add('spin');
}

export function removeSpinningClass(id) {
  let refreshIcon = document.getElementById(`refreshIcon-${id}`);
  refreshIcon.classList.remove('spin');
}

export async function refreshMailObject(id, url, targetObject) {
  addSpinningClass(id);
  try {
    const response = await putData(url, null, true);
    if (response) {
      const expiryTime =
        new Date().getTime() + changeMinutesToMiliSeconds(minutes);
      appendItem(targetObject, id, expiryTime);
      removeSpinningClass(id);
      return response?.data?.data;
    }
  } catch(err) {
    removeSpinningClass(id);
  }
}